import { queryOptions } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { api } from "@/api/api";
import type { FindCitiesOutputDto } from "@/types/codegen";
import type { City } from "@/types/types";

import { toTitleCase } from "../utils/titleCase";

const select = (response: AxiosResponse<FindCitiesOutputDto>): City[] => {
  const { cities } = response.data.data;

  return cities.map((city) => ({
    ...city,
    // IRIX returns city names in uppercase, so we need to convert them to title case
    name: toTitleCase(city.name),
    type: "CITY", // this is only needed for type errors, this value already has "CITY" type but generated types are set to 'string'
  }));
};

const topLocationsQueryOptions = (direction: "ORIGIN" | "DESTINATION") =>
  queryOptions({
    queryKey: ["top-locations", { direction }] as const,
    queryFn: ({ signal }) =>
      api.get<FindCitiesOutputDto>(`/top-cities`, {
        // we do not support pagination for top locations, so we can hardcode the values
        params: { direction, page: 1, perPage: 20 },
        signal,
      }),
    throwOnError: false,
    select,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });

export const topOriginsQueryOptions = () => topLocationsQueryOptions("ORIGIN");

export const topDestinationsQueryOptions = () =>
  topLocationsQueryOptions("DESTINATION");
